import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from "@angular/forms";
import { InputNumberComponent } from './input-number.component';
@NgModule({
    imports: [CommonModule, FormsModule],
    declarations: [InputNumberComponent],
    exports: [InputNumberComponent],
    providers: []
})
export class InputNumberModule { }


// WEBPACK FOOTER //
// ./src/angular_library/components/input-number/input-number.module.ts